module.exports = __webpack_public_path__ + "img/h2o-excretion.5b4cfd43.png";